import { notifyAppError } from '@/utils/http-common';

const notificationMixin = {
  methods: {
    notificateError(message) {
      notifyAppError(message);
    },
    notificateSuccess(message) {
      this.$notify({
        group: 'app',
        type: 'success',
        text: message,
        closeOnClick: true,
        duration: 3000
      });
    },
    notificateWarn(message) {
      this.$notify({
        group: 'app',
        type: 'warn',
        text: message,
        closeOnClick: true,
        duration: 3000
      });
    }
  }
};

export { notificationMixin as default };
